import { Button } from "@/components/buttons/button"
import CustomHead from "@/components/layouts/custom_head"
import Image from "next/image"

export default function NotFound() {
  return (
    <>
      <CustomHead title="Not Found" />
      <main className="relative flex h-[calc(100vh-8rem)] flex-col">
        <header className="flex h-14 w-full justify-start bg-main-200 px-2 xl:hidden">
          <Image
            src="/images/grafiniti-logo.png"
            width={200}
            height={200}
            alt="Grafiniti Logo"
            className="h-12 w-32"
          />
        </header>
        <section className="flex flex-1 flex-col items-center justify-center">
          <div className="flex flex-col gap-4 text-center">
            <h1 className="text-2xl font-bold">Page Not Found</h1>
            <p className="px-6 leading-relaxed sm:text-sm">
              Uh oh, we can't seem to find the page you're looking for.
            </p>
            <div className="flex justify-center gap-4">
              <Button onClick={() => window.history.back()} color="primary">
                Go Back
              </Button>
              <Button
                onClick={() => window.location.replace("/home")}
                color="tertiary">
                Home
              </Button>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}
